import { z, infer as ZodInfer } from "zod"
import { viewerSchema } from "../pubsub/viewers"
import { droneSchema } from "../pubsub/drones"

export const ThumbnailViewStateSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    zoom: z.number(),
})

export const LocationSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
})

export const projectRecordSchema = z.object({
    id: z.string(),
    sk: z.string(),
    name: z.string(),
    tagId: z.string().nullable().optional(),
    thumbnailUrl: z.string().optional(),
    thumbnailViewState: ThumbnailViewStateSchema.optional(),
    location: LocationSchema.optional(),
    updatedAt: z.string().or(z.number().transform(String)),
    createdAt: z.string().or(z.number().transform(String)),
    portfolioId: z.string(),
    createdBy: z.string(),
    updatedBy: z.string(),
    __type: z.literal("FIRE"),
    lastJobFlightId: z.string().optional(),
})

export const projectSchema = z.object({
    id: z.string(),
    name: z.string(),
    tagId: z.string().optional(),
    thumbnailUrl: z.string().optional(),
    thumbnailViewState: ThumbnailViewStateSchema.optional(),
    location: LocationSchema.optional(),
    orgId: z.string(),
    createdBy: z.string(),
    updatedAt: z.string(),
    createdAt: z.string(),
    updatedBy: z.string(),
    lastJobFlightId: z.string().optional(),
})

export const projectExtendedSchema = projectSchema.extend({
    viewers: z.array(viewerSchema),
    drones: z.array(droneSchema),
    isFavorite: z.boolean(),
})

export type ProjectRecord = ZodInfer<typeof projectRecordSchema>
export type Project = ZodInfer<typeof projectSchema>
export type ProjectExtended = ZodInfer<typeof projectExtendedSchema>
